import { Orbit } from 'loading-dev';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '../app/theme.tsx';

// Toast do sistema (WEB-133): cartão flutuante NEUTRO em todo tipo; quem diz se deu certo
// ou errado é o quadrado de cor à esquerda (o mesmo do `Badge` e do `Notice`), nunca o
// fundo. Sem `next-themes`: o tema vem do provider próprio do painel.

function Mark({ className }: { className: string }) {
  return <span aria-hidden="true" className={`block size-2 ${className}`} />;
}

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      icons={{
        success: <Mark className="bg-green" />,
        info: <Mark className="bg-muted-foreground" />,
        warning: <Mark className="bg-warning" />,
        error: <Mark className="bg-danger" />,
        // Tamanho por `size`: o CSS do loading-dev fica fora de @layer e ganharia de um
        // `size-4`.
        loading: <Orbit size={16} color="var(--muted-foreground)" />,
      }}
      toastOptions={{
        classNames: {
          // `!`: o CSS do sonner é `[data-sonner-toast][data-styled=true]`, mais
          // específico que um utilitário. A "borda" é o fio de `--shadow-surface`.
          toast: 'shadow-(--shadow-surface)! gap-2.5!',
          title: 'font-medium!',
          description: 'text-muted-foreground!',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'transparent',
          '--border-radius': 'var(--radius-xl)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
